import { getNestedProperty } from '@opallabs/lambda'
import { ServiceCollection, State, StateKeys } from '../../../../types'

type GetServices = (state: State) => ServiceCollection | undefined

export const getServices: GetServices = (state) =>
  getNestedProperty<ServiceCollection>(
    state,
    StateKeys.jsonApiEntities,
    StateKeys.service
  )
